import S3 from 'aws-sdk/clients/s3';
import KinesisVideo from 'aws-sdk/clients/kinesisvideo';
import CognitoIdentityServiceProvider from 'aws-sdk/clients/cognitoidentityserviceprovider';
import * as AWS from 'aws-sdk/global';
import 'whatwg-fetch';
import {RESTRICTED_BUCKET} from "../constants/constants";
import {requestAudioFile} from "./request";
import videoChatStore from "../containers/video-chat/store";


const FIRST_CHUNK_SIZE = Math.round(1024 * 1024 / 10);
const CHUNK_SIZE = Math.round(1024 * 1024);


const poolData = {
    UserPoolId: process.env.REACT_APP_AWS_POOL_ID,
    ClientId: process.env.REACT_APP_AWS_CLIENT_ID
};
let s3;
let s3Acc;
export let kinesisVideoClient = null;

/**
 * Get the file peaks from S3 by the file id
 * @param fileId    {String} The file id
 * @returns {Promise}
 */
export function getPeaks(fileId) {
    return new Promise((resolve, reject) => {
        s3.getObject({Bucket: RESTRICTED_BUCKET, Key: fileId + '.peaks'}, (err, data) => {
            if (err) {
                reject(err)
            } else {
                resolve(JSON.parse(data.Body.toString('utf8')));
            }
        });
    })
}

/**
 * Get the file metadata from S3 by the file id
 * @param fileId    {String} The file id
 * @returns {Promise}
 */
export function getMetadata(fileId) {
    return new Promise((resolve) => {
        s3.getObject({Bucket: RESTRICTED_BUCKET, Key: fileId + '.audioMetaData'}, (err, data) => {
            if (err) {
                resolve(null)
            } else {
                let jsonResp = JSON.parse(data.Body.toString('utf8'));
                resolve(jsonResp.tempo ? Math.round(jsonResp.tempo) : 100);
            }
        });
    })
}

/**
 * Get the file metadata from S3 by the file id
 * @param shareId    {String} The file id
 * @returns {Promise}
 */
export function getSharedata(shareId) {
    return new Promise((resolve) => {
        s3.getObject({Bucket: 'musico-public-bucket', Key: `share/${shareId}.share`}, (err, data) => {
            if (err) {
                resolve({})
            } else {
                resolve(JSON.parse(data.Body.toString('utf8')));
            }
        });
    })
}

/**
 * deprecated - for legacy
 *
 * Get track data from S3
 * @param fileId    {String}    The file id
 * @returns {Promise.<{bpm: *}>}
 */
export async function fetchBpmFromS3(fileId) {
    let bpm = null;
    try {
        bpm = await getMetadata(fileId);
    } catch (err) {
    }
    return {bpm: bpm}
}

function parseContentRange(contentRangeStr) {
    if (!contentRangeStr) {
        return {
            chunkNum: 0,
            total: 0,
            totalBytes: 0
        }
    }
    const rangeTokens = /bytes (.*?)-(.*?)\/(.*)/.exec(contentRangeStr);
    const totalBytes = rangeTokens[3];
    let total;
    if (totalBytes < FIRST_CHUNK_SIZE) {
        total = 1;
    } else if (totalBytes < CHUNK_SIZE) {
        total = 2;
    } else {
        total = 1 + Math.ceil(totalBytes / CHUNK_SIZE);
    }

    return {
        chunkNum: rangeTokens[1] / CHUNK_SIZE,
        total: total,
        totalBytes: totalBytes
    }
}

/**
 * Get track data from S3
 * @param key    {String}    The file id
 * @param chunk {Number} Chunk number
 * @param range
 * @returns the relevant data buffer
 */
export async function downloadChunk(key, chunk, range) {
    let fileParams = {
        Bucket: RESTRICTED_BUCKET,
        Key: key
    };

    if (chunk !== undefined) {
        let fromBytes;
        let toBytes;
        if (chunk === 0) {
            fromBytes = 0;
            toBytes = FIRST_CHUNK_SIZE - 1;
        } else if (chunk === 1) {
            fromBytes = FIRST_CHUNK_SIZE;
            toBytes = CHUNK_SIZE - 1;
        } else {
            fromBytes = (chunk - 1) * CHUNK_SIZE;
            toBytes = chunk * CHUNK_SIZE - 1;
        }

        if (range !== undefined) {
            toBytes = Math.min(toBytes, range.totalBytes - 1);
        }
        fileParams.Range = 'bytes=' + fromBytes + '-' + toBytes;
    }

    let data;
    try {
        data = await getFromS3(fileParams);
    } catch (err) {
        if (err.code === 'SignatureDoesNotMatch') {
            // try without Range header
            fileParams.Range = undefined;
            data = await getFromS3(fileParams);
        }
    }
    if (!data) {
        return null;
    }
    return ({
        range: parseContentRange(data.ContentRange),
        buffer: data.Body.buffer
    });
}

export async function downloadFull(key, progressCallback) {
    return requestAudioFile(key, progressCallback);
}

export async function downloadUrlAndUploadToS3(url, key) {
    let response = await fetch(url);
    let urlBuffer = await response.arrayBuffer();
    await uploadToS3(urlBuffer, key, 'image/png', null, 'musico-public-bucket', true);
    return key;
}

function getFromS3(params) {
    return new Promise((resolve, reject) => {
        s3.getObject(params, (err, data) => {
            if (err) {
                reject(err);
            } else {
                resolve(data);
            }
        })
    })
}


/**
 * Save file to S3
 * @param data  {*}   The data to store in S3
 * @param fileName  {String}    The file name/id in S3
 * @param type  {String}    The content type of the file
 * @param onProgressChange  {Function}  Callback function on upload progress
 * @param bucket {String} override default bucket
 * @param addCacheHeader
 * @param instanceObj upload manage {Object}
 * @returns {Promise}
 */
export function uploadToS3(data, fileName, type, onProgressChange, bucket, addCacheHeader = false, instanceObj = {}) {
    const useAcc = bucket === RESTRICTED_BUCKET;
    const s3ToUse = useAcc ? s3Acc : s3;
    const key = fileName;
    return new Promise((resolve, reject) => {
        instanceObj.manage = s3ToUse.upload({
            Bucket: bucket,
            Key: key,
            ContentType: type,
            CacheControl: addCacheHeader ? 'max-age=31536000, s-max-age=31536000' : null,
            Body: data
        }, (err, resp) => {
            if (err) {
                console.error('Error uploading file: ', err);
                reject(err);
            } else {
                resolve(resp);
            }
        }).on('httpUploadProgress', function (progress) {
            if (onProgressChange) {
                onProgressChange(fileName, progress);
            }
        });
    });
}

export function getS3SignedUrl(key, bucket = 'musico-restricted-bucket-v2') {
    if (!key) {
        return null;
    }
    return s3.getSignedUrl('getObject', {Bucket: bucket, Key: key});
}



/**
 * Authenticate user in AWS to allow access to s3, ddb, cognito
 * @param session {Object}     The user data object
 * @returns {Promise}   Returns the token if success else the error
 */

export function updateAwsCredentials(session) {
    return new Promise((resolve, reject) => {
        let loginTypes = {};
        loginTypes['cognito-idp.us-east-1.amazonaws.com/' + poolData.UserPoolId] = session.getIdToken().getJwtToken();
        AWS.config.update({
            region: process.env.REACT_APP_AWS_REGION,
            credentials: new AWS.CognitoIdentityCredentials({
                IdentityPoolId: process.env.REACT_APP_AWS_IDENTITY_POOL_ID,
                Logins: loginTypes
            })
        });

        s3 = new S3({region: process.env.REACT_APP_S3_REGION, signatureVersion: 'v4'});
        s3Acc = new S3({
            region: process.env.REACT_APP_S3_REGION,
            signatureVersion: 'v4',
            endpoint: 'musico-restricted-bucket-v2.s3-accelerate.amazonaws.com',
            s3BucketEndpoint: true
        });

        kinesisVideoClient = new KinesisVideo({
            region: process.env.REACT_APP_AWS_REGION,
            accessKeyId: AWS.config.credentials.accessKeyId,
            secretAccessKey: AWS.config.credentials.secretAccessKey,
            sessionToken: AWS.config.credentials.sessionToken,
            correctClockSkew: true,
        });

        AWS.config.credentials.get((err) => {
            if (err) {
                reject(err);
            } else {
                resolve(session);
            }
        });

    });
}

export function unauthenticatedAccess() {
    return new Promise((resolve, reject) => {
        AWS.config.update({
            region: process.env.REACT_APP_AWS_REGION,
            credentials: new AWS.CognitoIdentityCredentials({
                IdentityPoolId: process.env.REACT_APP_AWS_IDENTITY_POOL_ID,
                IdentityId: null
            })
        });
        AWS.config.credentials.params.IdentityId = null;

        s3 = new S3({region: process.env.REACT_APP_S3_REGION, signatureVersion: 'v4'});
        s3Acc = new S3({
            region: process.env.REACT_APP_S3_REGION,
            signatureVersion: 'v4',
            endpoint: 'musico-restricted-bucket-v2.s3-accelerate.amazonaws.com',
            s3BucketEndpoint: true
        });


        AWS.config.credentials.get((err) => {
            if (err) {
                reject(err);
            } else {
                resolve();
            }
        });
    });
}

export function getCognitoUser(session) {
    return new Promise((resolve, reject) => {

        let params = {
            AccessToken: session.getAccessToken().getJwtToken()  /* required */
        };
        let cognitoidentityserviceprovider = new CognitoIdentityServiceProvider();
        cognitoidentityserviceprovider.getUser(params, (err, data) => {
            if (err) {
                console.log(err);
                reject(err);
            } else {
                resolve(data);
            }
        });
    })
}

/**
 * Perform sign out in aws
 */
export function awsSignOut() {
    let cognitoCredentials = new AWS.CognitoIdentityCredentials({IdentityPoolId: process.env.REACT_APP_AWS_IDENTITY_POOL_ID});
    cognitoCredentials.clearCachedId();
    AWS.config.credentials = cognitoCredentials;
}


export function getStreamIfAvailable() {
    if (videoChatStore.stream) {
        return videoChatStore.stream.clone();
    }
    return null;
}